module.exports = __webpack_public_path__ + "img/arrow-left-square-fill.ee147fe2.svg";